import React, { useState } from "react";
import styles from "./SchoolOurMission.module.css";
import Image from "next/image";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface TitleDescription {
  id: number;
  title_description: TileDescription;
  images: Image[];
}

interface MissionProgram {
  id: number;
  title_description: TitleDescription;
  explanation_video_link: any;
}

interface Props {
  data: MissionProgram;
}

const SchoolOurMission: React.FC<Props> = ({ data }) => {
  const { explanation_video_link, title_description } = data;
  const videoURL = explanation_video_link?.link?.url || "";
  const videoId = videoURL.split("v=")[1];
  const [isVideoVisible, setIsVideoVisible] = useState(false);

  const handleThumbnailClick = () => {
    if (explanation_video_link) {
      setIsVideoVisible(true);
    }
  };

  return (
    <section className={styles.missionSection}>
      <div className="container">
        <div className={styles.missionContent}>
          <div className={styles.textContent}>
            <h2>{title_description?.title_description?.title}</h2>
            <p>{title_description?.title_description?.description}</p>

            {/* Accreditation Logos */}
            <div className={styles.accreditation}>
              <strong>Accredited By</strong>
              <div className={styles.logos}>
                {title_description?.images?.map((accreditation: Image) => (
                  <Image
                    key={accreditation?.id}
                    src={accreditation?.url}
                    alt={accreditation?.alternativeText || "Accreditation logo"}
                    title={
                      accreditation?.alternativeText || "Accreditation logo"
                    }
                    width={486}
                    height={188}
                    className={styles.accreditationLogo}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className={styles.videoContainer}>
            <div className={styles.video}>
              {!isVideoVisible ? (
                <div
                  className={styles.youtubeVideo}
                  onClick={handleThumbnailClick}
                  role="button"
                  tabIndex={0}
                  style={{
                    cursor: explanation_video_link ? "pointer" : "default",
                  }}
                >
                  {explanation_video_link?.image ? (
                    <Image
                      src={explanation_video_link?.image.url}
                      alt={
                        explanation_video_link?.image?.alternativeText ||
                        "Video thumbnail"
                      }
                      title={
                        explanation_video_link?.image?.alternativeText ||
                        "Video thumbnail"
                      }
                      width={400}
                      height={340}
                      layout="intrinsic"
                      className={styles.thumbnailImage}
                    />
                  ) : (
                    <div className={styles.noThumbnail}>
                      <p>No Thumbnail Available</p>
                    </div>
                  )}
                </div>
              ) : (
                <iframe
                  className={styles.youtubeVideo}
                  width="100%"
                  height="340"
                  src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&modestbranding=1&controls=1&rel=0&showinfo=0&iv_load_policy=3&fs=1&disablekb=1`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin"
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchoolOurMission;
